import { Component, OnInit, Input } from '@angular/core';
import { tPrescriptionHeadModel } from 'src/app/models/tPrescriptionHeadModel';
import { tPrescriptionLineModel_withStock } from 'src/app/models/tPrescriptionLineModel';
import { tConsultHeadModelWithPatientInfo } from 'src/app/models/tConsultHeadModel';
import { SystemDefaultModel, ChineseDefaultModel, EnglishDefaultModel } from 'src/app/models/non-master-model/SystemDefaultModel';
import { AppComponent } from 'src/app/app.component';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DateTimeConvertService } from 'src/app/services/CommonService/DateTimeConvert.service';
import { tOnConsultService } from 'src/app/services/tOnConsult.service';
import { isNullOrUndefined } from 'util';
import { MatTableDataSource } from '@angular/material';
import { DatePipe } from '@angular/common';
import { AppSettings } from 'src/app/shared/AppSettings';
import { tShopService } from 'src/app/services/tShop.service';
import { NavigationComponent } from 'src/app/pages/navigation/navigation.component';
import { tPatientService } from 'src/app/services/tPatient.service';
import { CrypService } from 'src/app/services/Non-Master/Cryp.service';

@Component({
  selector: 'app-patient-clinic-label',
  templateUrl: './patient-clinic-label.component.html',
  styleUrls: ['./patient-clinic-label.component.css']
})
export class PatientClinicLabelComponent implements OnInit {
  @Input() patientID: string;

  patient = {
    patientID:"",
    name:"",
    surname:"",
    dob:"",
    hkid:"",
    hkidDesc:"",
    registeredDate:"",
    caseDrID:"",
    gender:"",
    age:""
  };

  constructor(
    public activeModal: NgbActiveModal,
    private patientService : tPatientService,
    private crypService: CrypService,
    private datePipe : DatePipe
  ) { }

  ngOnInit() {
    this.initPatientInfo();
  }

  initPatientInfo(){
    this.patientService.getLabelPrint(this.patientID,1).subscribe(x=>{

      this.patient = x.data;
      this.patient.hkid = this.crypService.decryptStr(this.patient.hkid).toString();
    })
  }

  getMarginLeftWithName(length){
    return 60;
  }

  getDateFomrat(value){
    if(!value) return "";
    return this.datePipe.transform(value,AppSettings.dateFormat);
  }

}
